import React from 'react';
import withAuthorization from '../utils/withAuthorization';
import News from '../components/News';

const IndexPage = () => <News />;

export default withAuthorization(IndexPage);



// WEBPACK FOOTER //
// ./src/pages/index.js